﻿import 'Vendors/daterangepicker/daterangepicker.extend';
import 'Vendors/jquery.sticky'
import { UpdateSiteHeaderSticky } from 'Modules/headroom.js';
/* Custom Knockout binding: daterangepicker
*  required: daterangepicker.js
*/
(function () {

    var daterange_template = '<div class="daterangepicker dropdown-menu" style="display: none;">' +
            '<div class="dropdown-menu-shadow">' +
                '<div class="daterangepicker-content">' +
                    '<div class="modal-head w-100">' +
                        '<div class="modal-calendar-icon"></div>' +
                        '<div class="modal-title">' +
                            AppData.Translations["calendar_modal_headtext"] + 
                        '</div>' +
                            '<div class="modal-close"></div>' +
                        '<div class="dates-pannel">' +
                            '<div class="drp-selected-dates">'+
                                '<div class="drp-selected-startDate">' +
                                    '<span class="caption">'+ AppData.Translations["calendar_departure_date"] + '</span><span class="text"></span>' +
                                '</div>'+
                                '<div class="drp-selected-endDate">' + 
                                    '<span class="caption">'+ AppData.Translations["calendar_arrival_date"] + '</span><span class="text"></span>' +
                                '</div>'+
                            '</div>'+
                            '<div class="cf"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="drp-calendar left">' +
                        '<div class="calendar-table"></div>' +
                        '<div class="calendar-time"></div>' +
                    '</div>' +
                    '<div class="drp-calendar right">' +
                        '<div class="calendar-table"></div>' +
                        '<div class="calendar-time"></div>' +
                    '</div>' +
                    '<div class="ranges"></div>' +
                    '<div class="cf"></div>' +
                    '<div class="extra-pannel">' +
                        '<div class="extra-info" style="display: none;">' +
                            '<div class="extra-info-content">' +
                                '<div class="greenmark-info">' +
                                    '<div class="extra-info-waiter">' +
                                        '<div class="spin extra-info-spin"></div>' +
                                    '</div>' +
                                    '<span></span><div class="extra-info-text">' + AppData.Translations["calendar_helptext_recom_routes"] + '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="extra-buttons">' +
                            '<button class="btn daterange-clear">' + AppData.Translations["calendar_nodates"] + '</button>' +
                        '</div>' +
                        '<div class="cf"></div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                        '<div class="row">' +
                            '<div class="col-6 extra-info" style="display: none;">' +
                                '<div class="extra-info-content">' +
                                    '<div class="greenmark-info">' +
                                        '<div class="extra-info-waiter">' +
                                            '<div class="spin extra-info-spin"></div>' +
                                        '</div>' +
                                        '<span></span><div class="extra-info-text">' + AppData.Translations["calendar_helptext_recom_routes"] + '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="col extra-buttons">' +
                                '<button class="btn daterange-clear w-100">' + AppData.Translations["calendar_nodates"] + '</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

    var daterange_inline_template = '<div class="daterangepicker inline-view" style="display: none;">' +
        '<div class="daterangepicker-content">' +
            '<div class="drp-calendar left">' +
                '<div class="calendar-table"></div>' +
                '<div class="calendar-time"></div>' +
            '</div>' +
            '<div class="drp-calendar right">' +
                '<div class="calendar-table"></div>' +
                '<div class="calendar-time"></div>' +
            '</div>' +
            '<div class="ranges"></div>' +
            '<div class="cf"></div>' +
        '</div>' +
    '</div>';
    
    function useModalDropDown() {
        //var bp_Width = $(window).width();
        var bp_Width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
        return bp_Width < 768;
    }


    function getNumberOfMonths() {
        var bp_Width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;

        if (bp_Width < 480) return 24;
        if (bp_Width < 768) return 24;
        if (bp_Width < 1024) return 2;
        return 3;
    }

    ko.bindingHandlers.daterangepicker = {
        /*** Handle ExtraInfoShown ***/
        showExtraInfo: function (element, flgShow, flgWaiting) {
            var $element = $(element);
            var drp = $element.data('daterangepicker');
            //console.log("showExtraInfo: " + drp);
            if (drp && drp.container) {
                var $extraInfo = drp.container.find('.extra-info');
                if (flgShow) {
                    $extraInfo.show();
                } else {
                    $extraInfo.hide();
                }
                if (flgWaiting) {
                    $extraInfo.addClass("waiting");
                } else {
                    $extraInfo.removeClass("waiting");
                }
            }
        },
        setDates: function (element, dates) {
            if (!dates) return;
            dates = ko.unwrap(dates);

            var $element = $(element);
            var drp = $element.data('daterangepicker');
            if (!drp) return;

            if (typeof dates.initDate != "undefined") {
                drp.setInitDate(ko.unwrap(dates.initDate));
            }

            if (typeof dates.startDate != "undefined") {
                drp.setStartDate(ko.unwrap(dates.startDate));
            }
            if (typeof dates.endDate != "undefined") {
                drp.setEndDate(ko.unwrap(dates.endDate));
            }
            if (typeof dates.minDate != "undefined") {
                drp.setMinDate(ko.unwrap(dates.minDate));
            }
            if (typeof dates.maxDate != "undefined") {
                drp.setMaxDate(ko.unwrap(dates.maxDate));
            }
        },
        /*** Handle UpdateHighlight ***/
        updateHighlightDates: function (element) {
            var $element = $(element);
            var drp = $element.data('daterangepicker');
            //console.log("updateHighlightDates: " + drp);
            if (drp) {
                //FIXME sometimes calendar dates are not updated imediatly with new hilights 
                var isShowing = drp.isShowing || drp.container.is(":visible") || drp.container.css("display") != 'none';
                //console.log("updateHighlightDates: isShowing " + isShowing);
                if (isShowing) {
                    drp.hide();
                }

                drp.updateCalendars();
                //drp.updateView();

                if (isShowing) {
                    drp.show();
                }
            }
        },
        updateWidth: function (element) {
            if (!useModalDropDown()) {
                var $element = $(element);
                var $dropdown = $('.dropdown-menu');
                if ($dropdown) {
                    var $form = $element.parents(".search .searchbar-body");
                    if ($form && $form.length) {
                        var leftForm = $form.offset().left;
                        var newWidth = $form.outerWidth();
                        $dropdown.css({ "width": newWidth });
                        $dropdown.css({ "maxWidth": newWidth });
                        $dropdown.css({ "left": leftForm });
                    }
                }
            }
        },
        updateTitle: function (element, picker, value) {
            //$(element).val(picker.startDate.format('L') + ' - ' + picker.endDate.format('L'));
            var $element = $(element);
            var hasValue = false;
            var text = '';
            if (value != null) {
                var value1 = null;
                var value2 = null;
                if (value instanceof Array) {
                    value1 = ko.utils.unwrapObservable(value[0]);
                    value2 = ko.utils.unwrapObservable(value[1]);
                }
                var m1 = moment(value1);
                var m2 = moment(value2);
                
                if (m1.isValid() || m2.isValid()) {
                    var txtValue1 = '...';
                    if (m1.isValid()) {
                        if (m1.format('MMMM').length > 3) {
                            txtValue1 = m1.format('DD. MMM.');
                        } else {
                            txtValue1 = m1.format('DD. MMM');
                        }
                    }

                    var txtValue2 = '...';
                    if (m2.isValid()) {
                        if (m2.format('MMMM').length > 3) {
                            txtValue2 = m2.format('DD. MMM. YYYY');
                        } else {
                            txtValue2 = m2.format('DD. MMM YYYY');
                        }
                    }

                    text = txtValue1 + ' - ' + txtValue2;
                    hasValue = true;
                }
            }
            if ($element.is('input')) {
                $element.val(text);
            } else {
                if (text == '' && $element.attr('placeholder')) {
                    text = $element.attr('placeholder');

                }

                var $span = $element.find('span');
                if ($span.length > 0) {
                    $span.html(text);
                    if (hasValue) {
                        $span.removeClass('empty');
                    } else {
                        $span.addClass('empty');
                    }
                }
            }
        },
        writeValuesToModel: function (value, startDate, endDate) {
            var valueToWrite1 = null;
            var valueToWrite2 = null;
            //First - get all values
            if (startDate && startDate.isValid()) {
                valueToWrite1 = startDate.toDate();
            }
            if (endDate && endDate.isValid()) {
                valueToWrite2 = endDate.toDate();
            }
            //Second - set values to valueAccessor
            value[0](valueToWrite1);
            value[1](valueToWrite2);
        },
        init: function (element, valueAccessor, allBindingsAccessor) {
            //initialize daterangepicker with some optional options
            var unwrap = ko.utils.unwrapObservable;
            var binding = allBindingsAccessor();
            //var options = ko.utils.unwrapObservable(allBindingsAccessor().daterangepickerOptions) || {};
            var observable = valueAccessor();
            var eventHandlers = unwrap(binding.daterangepickerHandlers) || {};

            var options = {
                locale: {
                    //cancelLabel: 'Clear'
                    format: 'DD. MMM. YYYY',
                    weekLabel: AppData.Translations["week"],
                    monthNames: moment.months()
                },
                startDate: unwrap(observable[0]) || '',
                endDate: unwrap(observable[1]) || '',
                template: daterange_template,
                numberOfMonths: getNumberOfMonths,
                hideOtherMonthDays: true
            };
            if (binding.daterangepickerOptions) {
                //options = $.extend(options, unwrap(binding.daterangepickerOptions));
                let opt = unwrap(binding.daterangepickerOptions);
                opt = ko.toJS(opt);
                if (opt.inline) {
                    // default inline temlate
                    options.template = daterange_inline_template;
                }
                options = $.extend(options, opt);
            }

            //setTimeout(function () {
            // clean up memory when knockout removes binding
            ko.utils.domNodeDisposal.addDisposeCallback(element, function (disposingElement) {
                $(disposingElement).off('apply.daterangepicker');
                $(disposingElement).off('cancel.daterangepicker');
                $(disposingElement).off('show.daterangepicker');
                $(disposingElement).off('hide.daterangepicker');

                $(disposingElement).off('prevMonth.daterangepicker');
                $(disposingElement).off('nextMonth.daterangepicker');

                var drp = $(disposingElement).data('daterangepicker');
                drp.container.find('.daterange-clear').off('click');
                // not implemented yet
                //$(disposingElement).daterangepicker('destroy');
            });

            var handleDateRangePicker = function (start, end, label) {
                //console.log("CallBack: " +start.format('YYYY-MM-DD') + " - " +end.format('YYYY-MM-DD') + " Lable: " +label);
                //observable[0](start.toDate());
                //observable[1](end.toDate());

                if (typeof eventHandlers.callback == "function") {
                    eventHandlers.callback(start, end, label);
                }
            };

            var $element = $(element);
            $element.daterangepicker(options, handleDateRangePicker);
            var drp = $element.data('daterangepicker');
            var drp_view = drp.container[0];
            drp_view.id = ko.utils.uniqueId('ko-daterangepicker-');
            if (options.classes) {
                drp.container.addClass(options.classes);
            }
            drp.container.find('.extra-info .spin').each(function (i, elem) {
                //new Spinner({ color: '#36719c', lines: 11, length: 5, width: 2, radius: 4, corners: 1, trail: 58 }).spin(elem);
                //new Spinner({ color: '#36719c', lines: 11, length: 6, width: 2, radius: 3, corners: 1, trail: 58 }).spin(elem);
            });

            // FIXME 2018-01-19 Extract to settings if start reusing this plugin in other places of page
            // qtip classes with '.faded'
            var $header = $element.parents('.header');
            if ($header.length > 0) {
                if (!$header.hasClass('searchpage')) {
                    drp.container.addClass("faded");
                }
            }
            

            if (binding.clearDates) {
                var btn_clear = drp.container.find('.daterange-clear');
                ko.utils.registerEventHandler(btn_clear, 'click', function (event) {
                    binding.clearDates();
                    $element.data('daterangepicker').hide();
                });
            }

            if (binding.daterangepickerOptions) {
                var dateRangeOptions = unwrap(binding.daterangepickerOptions);

                // Subscribe to handle both changing
                if (ko.isObservable(binding.daterangepickerOptions)) {
                    binding.daterangepickerOptions.subscribe(function (newValue) {
                        var newOptions = unwrap(newValue);
                        if (newOptions != null) {
                            newOptions = ko.toJS(newOptions);
                            console.log('newOptions',newOptions);
                            $element.data('daterangepicker').updateOptions(newOptions);
                        }
                    });
                }
            }

            if (binding.dateRangeSettings) {
                var dateRangeSettings = unwrap(binding.dateRangeSettings);
                var extraInfoShown = dateRangeSettings.ExtraInfoShown || false;
                var extraInfoWaiting = dateRangeSettings.ExtraInfoWaiting || false;
                ko.bindingHandlers.daterangepicker.showExtraInfo(element, extraInfoShown, extraInfoWaiting);
                var dates = dateRangeSettings.Dates || null;
                ko.bindingHandlers.daterangepicker.setDates(element, dates);

                // Subscribe to handle both changing
                if (ko.isObservable(binding.dateRangeSettings)) {
                    binding.dateRangeSettings.subscribe(function (newValue) {
                        var newSettings = unwrap(newValue);
                        //updating ExtraInfoShown
                        var newExtraInfoShown = false;
                        if (newSettings != null) {
                            newExtraInfoShown = newSettings.ExtraInfoShown;
                        }
                        var newExtraInfoWaiting = newSettings.ExtraInfoWaiting || false;
                        ko.bindingHandlers.daterangepicker.showExtraInfo(element, newExtraInfoShown, newExtraInfoWaiting);

                        // updating dates (min/max, start/end)
                        var newDates = newSettings.Dates || null;
                        if (newSettings != null && newDates) {
                            ko.bindingHandlers.daterangepicker.setDates(element, newDates);
                        }

                        //updating UpdateHighlight
                        if (newSettings != null && newSettings.UpdateHighlight) {
                            ko.bindingHandlers.daterangepicker.updateHighlightDates(element);
                        }
                    });
                }
            }

            // handle the field changing
            ko.utils.registerEventHandler(element, 'apply.daterangepicker', function (event, picker) {
                //$(element).val(picker.startDate.format('L') + ' - ' + picker.endDate.format('L'));
                //console.log("Apply: " + picker.startDate.format('YYYY-MM-DD') + " - " + picker.endDate.format('YYYY-MM-DD'));
                ko.bindingHandlers.daterangepicker.writeValuesToModel(observable, picker.startDate, picker.endDate);
                //ko.bindingHandlers.daterangepicker.updateTitle(this, picker, observable);

                if (typeof eventHandlers.apply == "function") {
                    eventHandlers.apply(picker.startDate, picker.endDate);
                }
            });

            // handle the field clearing
            ko.utils.registerEventHandler(element, 'cancel.daterangepicker', function (event, picker) {
                //$(this).val('');
                ko.bindingHandlers.daterangepicker.writeValuesToModel(observable, null, null);
                //ko.bindingHandlers.daterangepicker.updateTitle(this, picker, observable);

                if (typeof eventHandlers.cancel == "function") {
                    eventHandlers.cancel();
                }
            });

            // handle the field changing
            ko.utils.registerEventHandler(element, 'prevMonth.daterangepicker', function (event, picker) {
                if (typeof eventHandlers.prevMonth == "function") {
                    eventHandlers.prevMonth(picker.calendarList);
                }
            });

            // handle the field changing
            ko.utils.registerEventHandler(element, 'nextMonth.daterangepicker', function (event, picker) {
                if (typeof eventHandlers.nextMonth == "function") {
                    eventHandlers.nextMonth(picker.calendarList);
                }
            });


            //drp.container.find('.modal-head').sticky({ topSpacing: 0, zIndex: 5, widthFromWrapper: false });
            function fixModalHeadHeight() {
                var drp3 = $element.data('daterangepicker');
                //console.log("fixModalHeadHeight: " + drp3);
                if (drp3 && drp3.container) {
                    var $contentHead = drp3.container.find('.modal-head');
                    var $stickyWrapper = $contentHead.parent('.sticky-wrapper');
                    if ($stickyWrapper.length == 0) {
                        var wrapper = $('<div></div>')
                            .addClass('sticky-wrapper');
                  
                            $contentHead.wrapAll(function() {
                                    return wrapper;
                            })
                            $stickyWrapper = $contentHead.parent('.sticky-wrapper');
                    }
                    $stickyWrapper.css('height', $contentHead.outerHeight(true));
                }
            };
            fixModalHeadHeight();

            function scrollToStartDate() {
                var drp3 = $element.data('daterangepicker');
                if (drp3 && drp3.container) {
                    var $contentHead = drp3.container.find('.modal-head');
                    var $dpContent = drp3.container.find('.daterangepicker-content');
                    var $drpCalendar = $(".drp-calendar:has(.start-date:not(.ends))");
                    if ($drpCalendar.length > 0 && $drpCalendar.offset()) {
                        $dpContent.animate({
                            scrollTop: $dpContent.scrollTop() + $drpCalendar.offset().top - $contentHead.outerHeight(true)
                        }, 500);
                    } else {
                        $dpContent.animate({
                            scrollTop: 0
                        }, 500);
                    }
                }
            };
            // handle the modal
            ko.utils.registerEventHandler(element, 'show.daterangepicker', function (event, picker) {
                if (picker && picker.inline) {
                    return;
                }
                if (picker && picker.element) {
                    var top = useModalDropDown() ? ($(window).scrollTop() || $('html, body').scrollTop()) : '';
                    picker.element.attr("data-last-top", top);
                }

                if (picker && picker.container) {
                    var $container = picker.container;

                    if (useModalDropDown()) {
                        $container.addClass("modal");
                        $('html').addClass("noscroll");

                        setTimeout(function () {
                            fixModalHeadHeight();
                            scrollToStartDate();
                        }, 100);

                        /* On some mobile browser when the overlay was previously
                        opened and scrolled, if you open it again it doesn't 
                        reset its scrollTop property */
                        //$dropdownContainerQtip.scrollTop = 0;

                        $container.find('.modal-close').on('click', function (e) {
                            if (picker) {
                                picker.hide();
                            }
                        });
                    } else {
                        $('html').removeClass("noscroll");
                        $container.removeClass("modal");
                    }
                }
                ko.bindingHandlers.daterangepicker.updateWidth(element);
                $(element).addClass('open');
                $(element).parents(".input-wrapper").addClass('open');
            });
            ko.utils.registerEventHandler(element, 'hide.daterangepicker', function (event, picker) {
                if (picker && picker.inline) {
                    return;
                }

                UpdateSiteHeaderSticky();
                if (picker && picker.container) {
                    var $container = picker.container;

                    $container.find('.modal-close').off('click');
                    $('html').removeClass("noscroll");
                }

                if (picker && picker.element) {
                    var scrollTop = picker.element.attr("data-last-top") || null;
                    if (scrollTop != null && $.isNumeric(scrollTop) && scrollTop >= 0) {
                        $('html, body').stop().delay(10).animate({
                            scrollTop: parseInt(scrollTop)
                        }, 0);
                    }
                }
                $(element).removeClass('open');
                $(element).parents(".input-wrapper").removeClass('open');
            });

            //var btn_close = drp.container.find('.modal-close');
            //ko.utils.registerEventHandler(btn_close, 'click', function (event) {
            //    $element.data('daterangepicker').hide();
            //});

            //}, 100);
            //return { controlsDescendantBindings: true }
        },
        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor()),
            $element = $(element);

            var value1 = ko.utils.unwrapObservable(value[0]) || '';
            var value2 = ko.utils.unwrapObservable(value[1]) || '';

            //handle date data coming via json from Microsoft
            //if (String(value1).indexOf('/Date(') == 0) {
            //    value1 = new Date(parseInt(value1.replace(/\/Date\((.*?)\)\//gi, "$1")));
            //}
            //if (String(value2).indexOf('/Date(') == 0) {
            //    value2 = new Date(parseInt(value2.replace(/\/Date\((.*?)\)\//gi, "$1")));
            //}

            var drp = $element.data('daterangepicker');

            var current1 = '';
            var current2 = '';
            if (drp) {
                if (drp.startDate) {
                    current1 = drp.startDate.toDate();
                }
                if (drp.endDate) {
                    current2 = drp.endDate.toDate();
                }
                if (value1 - current1 !== 0) {
                    //console.log("value1 " + value1);
                    drp.setStartDate(value1);
                }
                if (value2 - current2 !== 0) {
                    //console.log("value2 " + value2);
                    drp.setEndDate(value2);
                }
            }
            ko.bindingHandlers.daterangepicker.updateTitle(element, drp, value);
        }
    };

    /* Example of options
    $('#demo').daterangepicker({
        "locale": {
            "format": "MM/DD/YYYY",
            "separator": " - ",
            "applyLabel": "Apply",
            "cancelLabel": "Cancel",
            "fromLabel": "From",
            "toLabel": "To",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "daysOfWeek": [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            "monthNames": [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            "firstDay": 1
        },
        "startDate": "01/18/2018",
        "endDate": "01/24/2018"
    }, function(start, end, label) {
        console.log("New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')");
    });
    */

}).call(this);